// extracted by mini-css-extract-plugin
module.exports = {"actions":"internal-actions_actions__2hhVn"};